<template>
  <form-item-wrapper class="vform" :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <el-radio-group ref="fieldEditor" v-model="fieldModel" v-show="!isReadMode" :disabled="field.options.disabled"
      :size="field.options.size" :style="myStyles">
      <template v-if="!!field.options.buttonStyle">
        <el-radio-button @click.native.prevent="handleChangeRadio1(item.value)"
          v-for="(item, index) in field.options.optionItems" :key="index" :label="item.value" :disabled="item.disabled"
          :border="field.options.border" :style="{ display: field.options.displayStyle, ...myStyles }">{{
            item.label }}</el-radio-button>
      </template>
      <template v-else>
        <el-radio @click.native.prevent="handleChangeRadio1(item.value)"
          v-for="(item, index) in field.options.optionItems" :key="index" :label="item.value" :disabled="item.disabled"
          :border="field.options.border" :style="{ display: field.options.displayStyle, ...myStyles }">{{
            item.label }}</el-radio>
      </template>
    </el-radio-group>
    {{ }}
    <template v-if="isReadMode">
      <span class="readonly-mode-field">{{ optionLabel }}</span>
    </template>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from './form-item-wrapper'
import emitter from '@/utils/emitter'
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

export default {
  name: "radio-widget",
  componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    },

  },
  components: {
    FormItemWrapper,
  },
  inject: ['refList', 'globalOptionData', 'globalModel'],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
      debounceTimer: null,
    }
  },
  'field.options.defaultValue': {
    handler(n) {
      console.log(n);
      this.field.options.defaultValue = this.field.options.defaultValue ? this.field.options.defaultValue : ''
    }
  },
  computed: {
    myStyles() {
      return {
        'font-size': this.getFormConfig().fontSize + '!important',
        'font-weight': this.getFormConfig().fontWeight + '!important'
      }
    },
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
       需要在父组件created中初始化！！ */
    this.registerToRefList()
    this.initOptionItems()
    this.initFieldModel()
    this.initEventHandler()
    this.buildFieldRules()

    this.handleOnCreated()
  },

  mounted() {
    this.handleOnMounted()
  },

  beforeDestroy() {
    this.unregisterFromRefList()
  },

  methods: {

    handleChangeRadio1(value) {
      if(this.field.options.disabled) return
      if (value != this.fieldModel) {
        this.fieldModel = value
      } else {
        this.fieldModel = this.field.options.cancelChecked ? '' : this.fieldModel
      }
      this.handleChangeEvent(this.fieldModel)
      // this.handleChangeEvent(this.fieldModel)
      // console.log(val);
      // console.log(this.fieldModel);

    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) ::v-deep .el-radio__inner {
  box-shadow: 0 0 2px 2px #fff;
}

// .vform ::v-deep .el-radio {
//   font-weight: normal;

//   .el-radio__label {

//     font-size: unset;
//   }
// }
</style>
